/*eslint-disable*/
'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var assign = require('object-assign');
var velocity = require('velocity-animate');
var ScrollTo = function () {
  function ScrollTo() {
    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    _classCallCheck(this, ScrollTo);
    this.config = assign({}, {
      scrollDuration: 1000,
      scrollOffset: 0,
      linkClass: 'scroll-link',
      scrollEasing: 'swing',
      beginScroll: function beginScroll() {},
      endScroll: function endScroll() {}
    }, config);
  }
  _createClass(ScrollTo, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;
      var linkClass = this.config.linkClass;
      var _scrollL = Array.from(document.querySelectorAll('.' + linkClass));
      if (_scrollL.length) {
        var triggerEvents = ['click', 'touch'];
        _scrollL.forEach(function (el) {
          var _self = el;
          triggerEvents.forEach(function (event) {
            _self.addEventListener(event, _this.triggerScroll.bind(_this));
          });
        });
      }
    }
  }, {
    key: 'triggerScroll',
    value: function triggerScroll(e) {
      var _this2 = this;
      e.preventDefault();
      var _config = this.config;
      var scrollDuration = _config.scrollDuration;
      var scrollOffset = _config.scrollOffset;
      var scrollEasing = _config.scrollEasing;
      var beginScroll = _config.beginScroll;
      var endScroll = _config.endScroll;
      var linkClass = _config.linkClass;

      // calculate destination place

      var _dest = e.currentTarget.hash.substr(1);
      this._destId = document.getElementById(_dest);
      var _scrollEvents = ['scroll', 'mousedown', 'DOMMouseScroll', 'mousewheel', 'keyup'];

      // stop animation when user scrolls to stop jumping
      _scrollEvents.forEach(function (event) {
        document.body.addEventListener(event, _this2.stopVelocity.bind(_this2));
      });
      velocity(this._destId, 'scroll', {
        duration: scrollDuration,
        mobileHA: false,
        easing: scrollEasing,
        offset: scrollOffset,
        begin: function begin() {
          beginScroll();
        },
        complete: function complete() {
          //unbind the event listeners once the animation is complete
          _scrollEvents.forEach(function (event) {
            document.body.removeEventListener(event, _this2.stopVelocity.bind(_this2));
          });
          endScroll();
        }
      });
    }
  }, {
    key: 'stopVelocity',
    value: function stopVelocity() {
      velocity(this._destId, 'stop');
    }
  }]);
  return ScrollTo;
}();
module.exports = ScrollTo;